import { Button, Card, Text } from "../../../../components";
import Localization from "../../../../localization";
import { Images } from "../../../../assets";
import styled from "styled-components";
import { Flex } from "antd";
import React from "react";

const Inactive = ({ activate = () => {}, readMore = () => {} }) => (
  <Styled background={`url(${Images.alarmCentralInactiveCardBg})`}>
    <Text
      level={4}
      weight={700}
      lineHeight="normal"
      children={Localization.general.alarm_central}
    />
    <Text
      weight={700}
      type="secondary"
      className="m-5-t"
      children={Localization.service.alarm_central_inactive_subtitle}
    />
    <Text
      weight={400}
      type="secondary"
      className="m-30-t desc"
      children={Localization.service.alarm_central_inactive_desc}
    />
    <Flex className="m-50-t" gap={"1rem"}>
      <Button
        type="primary"
        onClick={activate}
        title={Localization.general.activate}
      />
      <Button onClick={readMore} title={Localization.general.read_more} />
    </Flex>
  </Styled>
);

const Styled = styled(Card)`
  .desc {
    padding-right: 6rem;
    ${(_) => _.theme.mobile(`padding-right: 0;`)}
  }
`;

export default Inactive;
